import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchSummary} from "../../../api/api";

const initialState = {
    SummaryData: [],
    loading: 'idle',
    error: null,
};

export const fetchSummaryData = createAsyncThunk(
    'summary/fetchSummaryData',
    async (options) => {
        options.newOKPDCode = options.selectedProduct.map(item => item.productId);
        const response = await fetchSummary(options);
        if ((response.status === 204 && response.data === "") || response.data.result === null) {
            return [];
        }
        return response.data.result;
    }
);

const summaryDataSlice = createSlice({
    name: 'summaryData',
    initialState,
    reducers: {
        resetSummaryData: (state) => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSummaryData.pending, (state) => {
                state.loading = 'pending';
            })
            .addCase(fetchSummaryData.fulfilled, (state, action) => {
                state.loading = 'successful';
                state.SummaryData = action.payload;
            })
            .addCase(fetchSummaryData.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.error.message;
            })
    },
});

export const { resetSummaryData } = summaryDataSlice.actions;

export default summaryDataSlice.reducer;
